import {
    Menu as MuiMenu,
    MenuProps as MuiMenuProps,
    styled,
} from "@mui/material";

export const Menu = styled(MuiMenu)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: "10px",
        border: "1px solid",
        borderColor: theme.palette.divider,
        boxShadow:
            "0 4px 12px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04)",
    },
    "& .MuiMenuItem-root": {
        fontSize: "0.8rem",
        borderRadius: "6px",
        marginLeft: 4,
        marginRight: 4,
        transition: "background-color 0.1s ease",
    },
}));

export type MenuProps = MuiMenuProps;
